import { TableProps } from 'antd';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getLanguageFromI18nLanguage } from '../../../shared/utils/language';
import { translationNamespace } from '../../constants/translation-resources';
import { Job } from '../../models/job';
import { getColumns } from './columns';
import { CustomTable } from '../../../shared/components/table';
import { permissionSelector } from '../../../shared/data/store/selectors/auth-selectors';

export const JobsTable: FC<Omit<TableProps<Job>, 'columns' | 'rowKey'>> = props => {
  const { t, i18n } = useTranslation(translationNamespace);
  const permissions = useSelector(permissionSelector);

  const columns = useMemo(
    () => getColumns(t, getLanguageFromI18nLanguage(i18n.language), permissions),
    [i18n.language, t, permissions]
  );

  return <CustomTable<Job> columns={columns} rowKey={job => job.id} {...props} />;
};
